import request from 'src/api/utils';
import * as ROUTES from 'src/api/routes';

export interface ApiKeyData {
    apiKeyId: number;
    prefix: string;
    label: string;
    scopes: string[];
    facilityIds: number[] | null;
    createdAt: string;
    expiresAt: string | null;
    isActive: boolean;
    lastUsedAt: string | null;
}

export interface CreateApiKeyData {
    label: string;
    scopes: string[];
    facilityIds?: number[] | null;
    expiresAt?: string;
}

export interface CreateApiKeyResponse extends ApiKeyData {
    plaintext: string;
}

export async function getApiKeys(includeRevoked?: boolean) {
    const result = await request({
        ...ROUTES.GET_API_KEYS,
        params: includeRevoked ? { includeRevoked: 'true' } : {},
    });
    return result.data.result as ApiKeyData[];
}

export async function createApiKey(data: CreateApiKeyData) {
    const result = await request({
        ...ROUTES.CREATE_API_KEY,
        data,
    });
    return result.data as CreateApiKeyResponse;
}

export async function revokeApiKey(apiKeyId: number) {
    const result = await request({
        ...ROUTES.REVOKE_API_KEY,
        pathParams: { apiKeyId },
    });
    return result.data;
}
